/* eslint-disable */
/** @todo - needs cleanup of eslint violations */
export default {
  flatten(data) {
    // recurses over a JSON tree, reducing down to a single array
    // (with keys reflective of the position in the tree
    const result = {}
    /**
     * @param cur
     * @param prop
     */
    function recurse(cur, prop) {
      let i, l
      if (Object(cur) !== cur) {
        result[prop] = cur
      } else if (Array.isArray(cur)) {
        for (i = 0, l = cur.length; i < l; i++) {
          recurse(cur[i], prop ? `${prop}.${i}` : `${i}`)
        }
        if (l == 0) result[prop] = []
      } else {
        let isEmpty = true
        for (const p in cur) {
          isEmpty = false
          recurse(cur[p], prop ? `${prop}.${p}` : p)
        }
        if (isEmpty) result[prop] = {}
      }
    }
    recurse(data, '')
    return result
  },
  /**
   * should only be used on relatively flat structures, if we need more complex uniq, we should plan on pulling lodash in
   *
   * @param arr
   * @returns {any[]}
   */
  uniq(arr) {
    return [...new Set(arr)]
  }
}
